import { render, staticRenderFns } from "./TreatmentEdit.vue?vue&type=template&id=ceecf120&"
import script from "./TreatmentEdit.vue?vue&type=script&lang=js&"
export * from "./TreatmentEdit.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports